// Popula a seção
function populateCatalogoGrid($parent, section, action = 'insert') {
  if ($parent.length > 0 && section) {
    // Atualiza a seção (Remove antes para ser criada novamente)
    if (action === 'update') {
      const $sectionUpd = $('#' + section.id);
      if ($sectionUpd.length > 0) {
        $sectionUpd.html('');
        $sectionUpd.remove();
      }
    }

    // Exibe seção
    const showSection = section['show'];
    const showSectionClass = !showSection ? 'd-none' : '';

    // Alinhamento do titulo
    const titAlignClass = section['tit-align'] == 'center' ? 'center' : '';

    // Estilo do bloco
    const prodBlOpts = {};
    prodBlOpts['prod-bl-side'] = section['grid-layout'] == 'side' ? 'prod-bl-side' : '';
    const prodColsDesktop = confTheme['products']['prod-bl-cols-desktop'] || 5;
    const prodColsTablet = confTheme['products']['prod-bl-cols-tablet'] || 3;
    const prodColsMobile = confTheme['products']['prod-bl-cols-mobile'] || 2;
    let gridClassDesktop;
    let gridClasTablet;
    let gridClasMobile;
    if (section['grid-layout'] == 'side') {
      gridClassDesktop = {
        3: 'grid-4',
        4: 'grid-4',
        5: 'grid-4',
        6: 'grid-4',
      };
      gridClasTablet = {
        2: 'grid-md-6',
        3: 'grid-md-6',
        4: 'grid-md-6',
      };
      gridClasMobile = {
        1: 'grid-sm-12 grid-xs-12',
        2: 'grid-sm-12 grid-xs-12',
      };
    } else {
      gridClassDesktop = {
        3: 'grid-4',
        4: 'grid-3',
        5: 'grid-2-4',
        6: 'grid-2',
      };
      gridClasTablet = {
        2: 'grid-md-6',
        3: 'grid-md-4',
        4: 'grid-md-3',
      };
      gridClasMobile = {
        1: 'grid-sm-12 grid-xs-12',
        2: 'grid-sm-6 grid-xs-6',
      };
    }
    prodBlOpts['grid-desktop'] = gridClassDesktop[prodColsDesktop];
    prodBlOpts['grid-tablet'] = gridClasTablet[prodColsTablet];
    prodBlOpts['grid-mobile'] = gridClasMobile[prodColsMobile];

    // Itens
    let itensHTML = `<div class="row catalogo-lista" data-aos="fade-up" data-aos-offset="0">
    </div>`;
    let $itens = $(itensHTML);
    const collectionInfos = getCollectionInfos(section['collection']);
    if (collectionInfos && collectionInfos['products'] && collectionInfos['products'].length > 0) {
      collectionInfos['products'].forEach((product) => {
        const itemHTML = mountProdBl(product, prodBlOpts, false);
        const $item = $(itemHTML);
        $itens.append($item);
      });
    }

    // Link "Ver todos"
    let linkViewAll = '';
    if (section['show-link'] == '1') {
      linkViewAll = `<a href="${collectionInfos['url']}" class="link link-arrow">Ver todos ${getSvgIcon(
        'arrow-right',
      )}</a>`;
    }

    // Estrutura da seção
    let sectionHTML = `
    <section id="${section['id']}" data-sec-type="catalogo_grid" class="home-section catalogo catalogo-grid bg-image ${showSectionClass}">
      <div class="carousel-sec-top">
        <div class="container">
          <div class="row catalogo-titulo-wrp" data-aos="fade-up" data-aos-offset="0">
            <div class="grid-12 catalogo-titulo-content ${titAlignClass}">
              <h2 class="title home-title md-text">${section['titulo']}</h2>
              ${linkViewAll}
            </div>
          </div>
        </div>
      </div>
      <div class="sec-content-grid">
        <div class="container">
          ${$itens[0].outerHTML}
        </div>
      </div>
      <div class="carousel-sec-bottom">
        <div class="container">
          <div class="row">
            <div class="grid-12"></div>
          </div>
        </div>
      </div>
    </section>`;

    // Cria o elemento
    let $section = $(sectionHTML);

    // Estilos
    if (Object.keys(section.styles).length > 0) {
      Object.keys(section.styles).forEach((styleVar) => {
        $section[0].style.setProperty('--' + styleVar, section.styles[styleVar]);
      });
    }

    // Ordem da seção
    $section[0].style.setProperty('--order', section['order']);
    $section[0].style.setProperty('order', section['order']);

    // Plano de fundo (Imagem)
    if (section['bg-type'] == 'image') {
      $section[0].style.setProperty('background-image', `url('${section['bg-image']}')`);
    }
    // Plano de fundo (Gradiente)
    else if (section['bg-type'] == 'gradient') {
      $section[0].style.setProperty('background-image', section['bg-gradient']);
    }

    $parent.append($section);
  }
}
